import { Navigate, Outlet } from "react-router";
import { useStaffAuth } from "@/lib/use-staff-auth";
import { staffCan, staffHomePath } from "@/lib/staff-capabilities";
import type { StaffCapability } from "@/lib/staff-capabilities";

interface StaffProtectedRouteProps {
  /** When set, a signed-in staff member without it is sent to their own home. */
  capability?: StaffCapability;
}

export function StaffProtectedRoute({ capability }: StaffProtectedRouteProps): React.ReactElement {
  const { staff, restoring } = useStaffAuth();

  if (restoring) {
    return (
      <p role="status" className="p-6 text-sm text-gray-600">
        Signing you in…
      </p>
    );
  }
  if (!staff) {
    return <Navigate to="/staff/login" replace />;
  }
  if (capability && !staffCan(staff.role, capability)) {
    return <Navigate to={staffHomePath(staff.role)} replace />;
  }
  return <Outlet />;
}
